import Vue from 'vue';

// Vue Packages
import Selectize from 'vue2-selectize';
import VueTextareaAutosize from 'vue-textarea-autosize';

import VueToastr from '@deveodk/vue-toastr';
import VModal from 'vue-js-modal';
import Sortable from 'sortablejs';
import * as VueGoogleMaps from 'vue2-google-maps';
import VueApexCharts from 'vue-apexcharts';

Vue.component('selectize', Selectize);

Vue.use(VueApexCharts);
Vue.use(VueTextareaAutosize);

Vue.component('apexchart', VueApexCharts);

Vue.use(VueToastr, {
	defaultPosition: 'toast-bottom-right',
	defaultType: 'success',
	defaultTimeout: 5000,
});

Vue.use(VModal);

Vue.directive('sortable', {
	inserted: function(el, binding) {
		el.sortable = Sortable.create(el, binding.value || {});
	},
	update: function(el, binding) {
		Object.keys(binding.value).forEach(key => {
			el.sortable.option(key, binding.value[ key ]);
		});
	},
});

Vue.use(VueGoogleMaps, {
	load: {
		key: 'AIzaSyBSneQ_bocV-ow3pQPX9c1KeK7-StZ6l9Q',
		libraries: 'places', // This is required if you use the Autocomplete plugin
		// OR: libraries: 'places,drawing'
		// OR: libraries: 'places,drawing,visualization'
		// (as you require)
	},
});
